function isEqualNode(nodeToFind, node) {
  return nodeToFind.isEqualNode(node);
}

export function positionNodeOptionsOpener(nodeOptionsOpener) {

  if (nodeOptionsOpener === null) {
    return;
  }

  const nodeHandlesContainer = nodeOptionsOpener.parentNode;
  const editorMainNode = nodeHandlesContainer.parentNode;
  const children = editorMainNode.querySelectorAll(':scope > *');
  const nodeHandlesContainers = Array.from(editorMainNode.querySelectorAll('.node-handles-container'));

  let contentNode = null;

  for (let child of children) {

    if (nodeHandlesContainers.find(isEqualNode.bind(null, child))) {
      continue;
    }

    if (child.classList.contains('editor-node-options-button') === true) {
      continue;
    }

    contentNode = child;
    break;

  }

  nodeHandlesContainer.style.left = (contentNode.offsetLeft - 20) + 'px';

  nodeHandlesContainer.parentNode.querySelector('.editor-node-options-button').style.left = (contentNode.offsetLeft + contentNode.offsetWidth + 2) + 'px';

}

export function determineWrapperStyles(node) {

  const properties = node.properties || {};
  let styles = {};

  if (properties !== void 0 && properties.alwaysFullWidth === true) {
    styles.width = '100%';
  }

  return styles;

}

export function determineStyleHostClass(element) {

  if (element.resizable === true) {
    return '.editor-resizable-layer-main .editor-element';
  }

  return '.editor-element';

}